import React from "react"

const Redirect: React.FC<{ redirectUrl: string }> = ({ redirectUrl }) => {
  window.location.replace(redirectUrl)
  return (
    <p>
      You are being redirected to <a href={redirectUrl}>{redirectUrl}</a>
    </p>
  )
}

export default Redirect
